<template>
   <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="20%"
    >
      <i class="el-icon-warning"></i>
      <span>{{ message }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="bcBtn" @click="dialogVisible = false">取 消</el-button>
        <el-button class="comBtn" @click="fun_Submit" :disabled="confirm !== '0'">{{ confirm === '0' ? '确 定' : confirm }}</el-button>
      </span>
    </el-dialog>
</template>
<script>
  export default {
    data: () => {
      return {
        // 弹窗
        dialogVisible:false,
        // 确认显示信息
        confirm: null,
        // 定时任务
        timer: null,
        // 初始倒计时数
        sencond: 10,
      }
    },
    // 接收来自父组件的数据
    props: {
      // 提示信息
      message: {
        type: String,
        default: ""
      },
    },
    // 自定义事件
    methods: {
      /**
       * 提交
       */
      fun_Submit(){
        // $emit事件传递
        this.$emit("fun_Submit");
      },
      /**
       * 倒计时方法
       */
      fun_SetInterval(){
        // 倒计时10秒
       this.sencond = 10;
       // 停止定时
       clearInterval(this.timer);
       // 确认信息
       this.confirm = `${this.sencond}`;
       // 打开弹窗
       this.dialogVisible = true;
       // 倒计时
       this.timer = setInterval(() => {
         this.sencond--;
         if (this.sencond == 0) {
           clearInterval(this.timer);
         }
         this.confirm = `${this.sencond}`;
       }, 1000);
      }
    }
  }
</script>
<style lang="scss" scoped>
/deep/.el-dialog {
  .el-dialog__header{
    .el-dialog__title{
      font-size: 16px;
    }
  }
  .el-dialog__body {
    position: relative;
    display: block;
    unicode-bidi: isolate;
    .el-icon-warning {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px !important;
      color: #E6A23C;
    }
    span {
      padding-left: 36px;
      padding-right: 12px;
      display: block;
      unicode-bidi: isolate;
    }
  }
  .dialog-footer {
    .el-button:nth-child(2) {
      background-color: #0E70B5 !important;
      border-color: #0E70B5 !important;
    }
  }
}
</style>